const getters = {
  isLogin: (state) => state.token,
  userInfo: (state) => state.userInfo || {},
  moneyDeposit: (state) => state.moneyDeposit || 0,
};

export default getters;
